import axios from "axios";
import apiPath from "../constants/apiPath";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Severty, ShowToast } from "../helper/toast";

const client = axios.create({
  baseURL: apiPath.baseURL,
});

const useRequest = () => {
  const { logout } = useContext(AuthContext);

  const request = async ({
    url,
    method: tmethod,
    data,
    onSuccess,
    onError,
    header,
    onErrorSubmit,
  }) => {
    const method = tmethod.trim().toUpperCase();
    console.log(method);
    let token = localStorage.getItem("token")
      ? localStorage.getItem("token")
      : "";

    console.log(token);

    const headers = {
      ...header,
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await client({
        url,
        method,
        data,
        headers: { ...headers },
      });

      if (onSuccess) {
        onSuccess(response.data);
      } else {
        onErrorSubmit(response.data);
      }
      return response.data;
    } catch (err) {
      const data = err?.response?.data;
      const backendMessage = data?.message || (Array.isArray(data?.errors) && data.errors[0]?.message);
      if (backendMessage) err.message = backendMessage;

      if (err?.response?.code === "ERR_NETWORK") {
        console.log("ErrorNetwork");
      }
      if (err?.response?.status === 401) {
        logout(1);
      }
      if (err?.response?.status === 403) {
        logout(1);
      }
      if (data?.message === "jwt expired") {
        logout(1);
      }

      if (err?.response?.status === 400 && data?.errors?.length) {
        data.errors.forEach((item) => ShowToast(item?.message, Severty.ERROR));
      }

      if (onError) onError(err);
      // throw err;
    }
  };

  return { request };
};

export default useRequest;
